import { render } from "./BarPassageOutcomes.vue?vue&type=template&id=b74773a0&scoped=true"
import script from "./BarPassageOutcomes.vue?vue&type=script&lang=js"
export * from "./BarPassageOutcomes.vue?vue&type=script&lang=js"

import "./BarPassageOutcomes.vue?vue&type=style&index=0&id=b74773a0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74773a0"]])

export default __exports__